import ga from "@store/Framework/Common/GoogleAnalytics";

const mapOrderOption = (options: Toolkit.GoogleAnalytics.Options | undefined): Toolkit.GoogleAnalytics.Event => {
    if (!options?.order) {
        return {};
    }

    const { order } = options;
    options.promotions = order.orderPromotions;

    return {
        ...ga.map.promotionsOption(options),
        item_list_id: order.id,
        items: !options?.skipOptionItems ? ga.map.items(order.orderLines) : undefined,
        shipping: order.shippingAndHandling,
        tax: order.taxAmount,
        value: order.orderTotal,
    };
};

export default mapOrderOption;
